import { render, staticRenderFns } from "./InformationProtection.vue?vue&type=template&id=09c984ac"
import script from "./InformationProtection.vue?vue&type=script&lang=js"
export * from "./InformationProtection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports